import React from 'react';
import { TabelaPermissoes } from '../../components/TabelaPermissoes';
import MenuMain from '../../MenuMain';
import { AppFooter } from '../../AppFooter';


export default function PermissoesPage() {

  return (
    <div className="p-pt-0">
      <MenuMain >
        <TabelaPermissoes />
      </MenuMain>
      <AppFooter />
    </div>
  );
}
